import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Row, Button, Input, Form, notification, Modal, Upload, Collapse, Popconfirm,
} from 'antd';

import { CloseCircleOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { editApplications2, getApplications2, getApplications2ById, uploadFile } from '../../../../utils/http';
import { FilesModal } from './FilesModal';
import fileDownload from '../../../../utils/fileDownload';
import fileOpenNewTab from '../../../../utils/fileOpenNewTab';


export const DocumentsList = ({ applicationProp, getMethod, postMethod }) => {
  const [application, setApplication] = useState(null);

  const [filesUploadModal, setFilesUploadModal] = useState({
    show: false,
    field: '',
    indexToShow: undefined,
  });

  useEffect(() => {
    const getGrantAgreement = () => {
      if (typeof applicationProp.grant_agreement === 'string') {
        return JSON.parse(applicationProp.grant_agreement);
      }

      if (typeof applicationProp.grant_agreement === 'object') {
        return applicationProp.grant_agreement;
      }

      return [];
    };

    const getAdditionalAgreements = () => {
      if (typeof applicationProp.additional_agreements === 'string') {
        return JSON.parse(applicationProp.additional_agreements);
      }

      if (typeof applicationProp.additional_agreements === 'object') {
        return applicationProp.additional_agreements;
      }

      return [];
    };

    setApplication({
      ...applicationProp,
      grant_agreement: getGrantAgreement(),
      additional_agreements: getAdditionalAgreements(),
    });
  }, [applicationProp]);

  const refetchApplication = async () => {
    const resp = await getMethod(application.id);
    setApplication(resp);
  };

  const handleRemoveFile = async (field, id) => {
    const newFiles = application[field].filter((f) => f.id !== id);

    try {
      await postMethod({ id: application.id, [field]: JSON.stringify(newFiles) });
      await refetchApplication();
      notification.success({ message: 'Удалено' });
    } catch {
      notification.error({ message: 'Ошибка. Попробуйте еще раз' });
    }
  };


  return (
    <div className="application-main-box-wrapper" style={{ paddingBottom: '20px' }}>
      <div className="application-main-box-mask" style={{ background: '#fff' }} />
      {getUserRole() === 'bigAdmin' && (
        <>
          <div className="application-main-box-content-wrapper" style={{ marginBottom: '-30px' }}>
            <div className="application-main-label">Документы</div>
          </div>
        </>
      )}

      <Col span={24} style={{ padding: '10px 20px' }}>
        <Row justify="space-between">
          <Col>
            <span style={{ fontSize: '18px' }}>
              Грантовые соглашения
            </span>
          </Col>
          {getUserRole() === 'bigAdmin' && (
            <Col>
              <Button onClick={() => {
                setFilesUploadModal({
                  show: true,
                  field: 'grant_agreement',
                });
              }}
              >
                Загрузить новое
              </Button>
            </Col>
          )}
        </Row>
        {application?.grant_agreement?.map((f, i) => (
          <Row key={f.id} style={{ margin: '10px 0px', width: '100%' }} align="middle">
            <Col><Button type="primary" icon={<DownloadOutlined />} onClick={() => fileDownload(f.pdf.urlLink, f.pdf.name)} style={{ marginRight: '10px' }} /></Col>
            <Col><Button type="primary" icon={<EyeOutlined />} onClick={() => fileOpenNewTab(f.pdf.urlLink)} style={{ marginRight: '10px' }} /></Col>
            <Popconfirm
              title="Уверены, что хотите удалить файл?"
              onConfirm={() => handleRemoveFile('grant_agreement', f.id)}
              okText="Да"
              cancelText="Нет"
            >
              <Col><Button type="danger" icon={<CloseCircleOutlined />} style={{ marginRight: '10px' }} /></Col>
            </Popconfirm>

            <Col>{f.pdf.name}</Col>

            <Button type="primary" style={{ marginLeft: 'auto' }} onClick={() => setFilesUploadModal({ show: true, field: 'grant_agreement', indexToShow: i })}>Доп. файлы</Button>
          </Row>
        ))}
      </Col>

      <Col span={24} style={{ padding: '10px 20px' }}>
        <Row justify="space-between">
          <Col>
            <span style={{ fontSize: '18px' }}>
              Дополнительные соглашения
            </span>
          </Col>
          {getUserRole() === 'bigAdmin' && (
            <Col>
              <Button onClick={() => {
                setFilesUploadModal({
                  show: true,
                  field: 'additional_agreements',
                });
              }}
              >
                Загрузить новое
              </Button>
            </Col>
          )}
        </Row>
        {application?.additional_agreements?.map((f, i) => (
          <Row key={f.id} style={{ margin: '10px 0px', width: '100%' }} align="middle">
            <Col><Button type="primary" icon={<DownloadOutlined />} onClick={() => fileDownload(f.pdf.urlLink, f.pdf.name)} style={{ marginRight: '10px' }} /></Col>
            <Col><Button type="primary" icon={<EyeOutlined />} onClick={() => fileOpenNewTab(f.pdf.urlLink)} style={{ marginRight: '10px' }} /></Col>
            <Popconfirm
              title="Уверены, что хотите удалить файл?"
              onConfirm={() => handleRemoveFile('additional_agreements', f.id)}
              okText="Да"
              cancelText="Нет"
            >
              <Col><Button type="danger" icon={<CloseCircleOutlined />} style={{ marginRight: '10px' }} /></Col>
            </Popconfirm>

            <Col>{f.pdf.name}</Col>

            <Button type="primary" style={{ marginLeft: 'auto' }} onClick={() => setFilesUploadModal({ show: true, field: 'additional_agreements', indexToShow: i })}>Доп. файлы</Button>
          </Row>
        ))}
      </Col>

      {filesUploadModal.show && (
        <FilesModal
          onHide={() => {
            setFilesUploadModal({ show: false, field: '' });
          }}
          application={application}
          files={typeof filesUploadModal.indexToShow === 'number' ? application[filesUploadModal.field][filesUploadModal.indexToShow] : {}}
          onSuccess={() => {
            setFilesUploadModal({ show: false, field: '' });
            refetchApplication();
          }}
          fieldName={filesUploadModal.field}
          postMethod={postMethod}
        />
      )}

    </div>
  );
};

DocumentsList.propTypes = {
  applicationProp: PropTypes.shape().isRequired,
  getMethod: PropTypes.func.isRequired,
  postMethod: PropTypes.func.isRequired,
};
